export class CentroEntrenamiento {
  constructor(
    public id: number,
    public nombre: string,
    public direccion: string | null,
    public idInstructor: number | null,
    public activo: boolean = true,
    public isEditMode: boolean = false,
    public disableValidation: boolean = false
  ) {
    // Validate  id and nombre
    if (!disableValidation && (!id || !nombre)) {
      throw new Error("id and nombre are required fields and cannot be null");
    }
  }

  static fromRows(rows: any[]): CentroEntrenamiento[] {
    return rows.map(
      (row) =>
        new CentroEntrenamiento(
          row.id,
          row.nombre,
          row.direccion,
          row.idInstructor,
          row.activo
        )
    );
  }

  static fromRawData(data: any): CentroEntrenamiento {
    return new CentroEntrenamiento(
      data.id,
      data.nombre || '',
      data.direccion !== undefined ? data.direccion : null,
      data.idInstructor !== undefined ? data.idInstructor : null,
      data.activo !== undefined ? data.activo : true
    );
  }

  fill(newFields: Partial<CentroEntrenamiento>): void {
    for (let field in newFields) {
      if (this.hasOwnProperty(field) && newFields.hasOwnProperty(field)) {
        const key = field as keyof CentroEntrenamiento;
        if (this[key] !== undefined) {
          (this[key] as any) = newFields[key]!;
        }
      }
    }
  }

  get nombreDireccion(): string {
    return `${this.nombre} ${this.direccion}`;
  }
}